import React, { PropsWithChildren } from 'react'

type Props = {
    title?: string;
}

const Card = ({title, children}:PropsWithChildren & Props) => {
  return (
    <div className='flex flex-col w-full gap-3 p-4 overflow-auto border rounded-md md:gap-4 md:p-6'>
        {title && <p className='text-xl font-semibold'>{title}</p>}
        <div className='flex flex-col w-full gap-4'>
            {children}
        </div>
    </div>
  )
}

export default Card